import { Box, Typography } from "@mui/material";
import React from "react";

import { monospaceStyle } from "../../theme";

export interface FilterPanelProps {
  // The number of active filters, shown in the panel's head
  activeCount: number;
  // The sections
  children: React.ReactNode;
}

// The box of a filter panel: one surface with a hairline border, a head
// that says "Filters" and how many are active, and the sections beneath.
// It takes the width of the column it is put in.
const FilterPanel: React.FC<FilterPanelProps> = ({ activeCount, children }) => (
  <Box
    component="aside"
    aria-label="Filters"
    sx={{
      backgroundColor: "background.paper",
      border: 1,
      borderColor: "divider",
      borderRadius: (theme) => `${theme.radius.surface}px`,
      overflow: "hidden",
      // The sections carry space above them only; this closes the last one
      pb: 1,
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "baseline",
        justifyContent: "space-between",
        px: 1.5,
        py: 1,
      }}
    >
      <Typography variant="subtitle2" component="h2">
        Filters
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={monospaceStyle}>
        {`${activeCount} active`}
      </Typography>
    </Box>
    {children}
  </Box>
);

export default FilterPanel;
